import { Entity, ShareholderRecord } from '../classes';

export class Entities {
  public static getPersonEntityName(entity: Entity): string {
    return (
      (entity.firstName || (entity.users && entity.users[0] && entity.users[0].firstName)) +
      ' ' +
      (entity.lastName || (entity.users && entity.users[0] && entity.users[0].lastName))
    );
  }
  public static getEntityName(entity: Entity) {
    if (entity && entity.isCompany) {
      return entity.companyname || '';
    } else if (entity && entity.firstName && entity.lastName) {
      return entity.firstName + ' ' + entity.lastName;
    } else if (
      entity &&
      entity.users &&
      entity.users[0] &&
      entity.users[0].firstName &&
      entity.users[0].lastName
    ) {
      return entity.users[0].firstName + ' ' + entity.users[0].lastName;
    } else {
      return '';
    }
  }
  public static getEntityEmail(entity: Entity) {
    if (entity && entity.users && entity.users[0] && entity.users[0].email) {
      if (entity.users[0].email === 'email?') {
        return '';
      }
      return entity.users[0].email;
    } else if (entity && entity.email === 'email?') {
      return entity.email;
    } else if (entity && entity.email) {
      return entity.email;
    } else {
      return '';
    }
  }
  public static getOrgContactName(entity: Entity) {
    let name = '';
    if (entity && entity.isCompany) {
      if (entity.users && entity.users.length > 0) {
        if (entity.users[0].firstName) {
          name = entity.users[0].firstName + ' ' + entity.users[0].lastName;
        }
      }
    }
    return name;
  }

  public static getEntityOrgnrOrSsn(entity: Entity) {
    if (entity && entity.isCompany) {
      return entity.orgnr;
    } else {
      return (
        ((entity && entity.dob) || '') +
        (entity && entity.pnr ? ' ' : '') +
        ((entity && entity.pnr) || '')
      );
    }
  }

  public static getEntityCountFromMapAndRecords(
    entityMap: { [key: string]: Entity },
    records: ShareholderRecord[]
  ): number {
    if (entityMap) {
      return Object.keys(
        records.reduce((acc, record: ShareholderRecord) => {
          acc[record.entityId] = true;
          return acc;
        }, {})
      ).length;
    } else {
      return 0;
    }
  }
}
